var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    Object.keys(_vm.orderStatistics).length
      ? _c(
          "table",
          { staticClass: "table table-sm table-hover table-bordered" },
          [
            _c("thead", [
              _c(
                "tr",
                { staticClass: "highlight text-center" },
                [
                  _c("th"),
                  _vm._v(" "),
                  _vm._l(_vm.$AllProjects, function (project) {
                    return _c(
                      "th",
                      { key: project.id, attrs: { colspan: "2" } },
                      [_vm._v(_vm._s(project.title))]
                    )
                  }),
                  _vm._v(" "),
                  _c("th", { attrs: { colspan: "2" } }, [_vm._v("Итого")]),
                ],
                2
              ),
            ]),
            _vm._v(" "),
            _c(
              "tbody",
              _vm._l(_vm.reportIndexes, function (recordName, index) {
                return _c(
                  "tr",
                  [
                    _c("td", [_vm._v(_vm._s(recordName))]),
                    _vm._v(" "),
                    _vm._l(_vm.$AllProjects, function (project) {
                      return [
                        _c(
                          "td",
                          [
                            _vm.orderStatistics[project.id] &&
                            _vm.orderStatistics[project.id][index] &&
                            _vm.orderStatistics[project.id][index].ids &&
                            _vm.orderStatistics[project.id][index].ids.length
                              ? [
                                  _c(
                                    "a",
                                    {
                                      attrs: { href: "#" },
                                      on: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          return _vm.mixinGoToRouter(
                                            "searchOrder",
                                            {
                                              ordersId:
                                                _vm.orderStatistics[project.id][
                                                  index
                                                ].ids,
                                            }
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.orderStatistics[project.id][index]
                                            .ids.length
                                        )
                                      ),
                                    ]
                                  ),
                                ]
                              : [_vm._v("0")],
                          ],
                          2
                        ),
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              (_vm.orderStatistics[project.id] &&
                                _vm.orderStatistics[project.id][index] &&
                                _vm.orderStatistics[project.id][index].total) ||
                                0
                            ) + "\n        "
                          ),
                        ]),
                      ]
                    }),
                    _vm._v(" "),
                    _c("td", { staticClass: "highlight" }, [
                      _vm._v(
                        _vm._s(
                          (_vm.orderStatistics.total[index] &&
                            _vm.orderStatistics.total[index].ids.length) ||
                            0
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "highlight" }, [
                      _vm._v(
                        _vm._s(
                          (_vm.orderStatistics.total[index] &&
                            _vm.orderStatistics.total[index].total) ||
                            0
                        )
                      ),
                    ]),
                  ],
                  2
                )
              }),
              0
            ),
            _vm._v(" "),
            _c("tfoot", [
              _c(
                "tr",
                { staticClass: "highlight" },
                [
                  _c("th", [_vm._v("итого общее")]),
                  _vm._v(" "),
                  _vm._l(_vm.$AllProjects, function (project) {
                    return [
                      _c("th", [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              (_vm.orderStatistics[project.id] &&
                                _vm.orderStatistics[project.id].total.ids
                                  .length) ||
                                0
                            ) +
                            "\n        "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("th", [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              (_vm.orderStatistics[project.id] &&
                                _vm.orderStatistics[project.id].total.total) ||
                                0
                            ) +
                            "\n        "
                        ),
                      ]),
                    ]
                  }),
                  _vm._v(" "),
                  _c("th", [
                    _vm._v(_vm._s(_vm.orderStatistics.total.total.ids.length)),
                  ]),
                  _vm._v(" "),
                  _c("th", [
                    _vm._v(_vm._s(_vm.orderStatistics.total.total.total)),
                  ]),
                ],
                2
              ),
            ]),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }